import { errorSlotName, hintSlotName } from "../common/components/action/slotNames.ts";
import { ensureId } from "../common/components/action/utils/ensureId.ts";
import { getAriaLabelFromInteractiveElement } from "./utils/getAriaLabelFromInteractiveElement.ts";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const setAriaLabel = (element: HTMLElement, Host: HTMLElement): void => {
  /*                                                                             */
  /*                                                                                    */
  if (
    element instanceof HTMLInputElement ||
    element instanceof HTMLButtonElement ||
    element instanceof HTMLSelectElement ||
    element instanceof HTMLTextAreaElement
  ) {
    const otherChildren = Array.from(Host.childNodes).filter((child) => {
      /*                                                                            */
      if (child instanceof Text) return child.textContent.trim().length! > 0;

      /*                                                                                     */
      if (child instanceof HTMLElement) {
        return child !== element && ![errorSlotName, hintSlotName].includes(child.slot);
      }

      /*                                                                             */
      return false;
    });

    /*                                                                                       */
    if (otherChildren.every((c) => c instanceof HTMLLabelElement)) {
      /*                                                                                    */
      const inputId = ensureId(element);
      otherChildren
        .filter((child): child is HTMLLabelElement => child instanceof HTMLLabelElement)
        .forEach((label) => (label.htmlFor = inputId));

      /*                                                                           */
      element.ariaLabel = null;
      return;
    }
  }

  /*                                                                                   */
  element.ariaLabel = getAriaLabelFromInteractiveElement(Host);
};
